import { v4 as uuidv4 } from 'uuid'
import { ExternalAspectData, newExternalAspectData } from "src/app/core/comparable/_models/asset-class-external-aspect.model";
import { InternalAspectData, newInternalAspectData } from "src/app/core/comparable/_models/asset-class-internal-aspect.model";
import { LocationData } from "src/app/core/comparable/_models/location.model";
import { EsgIndicator } from "src/app/core/v2/state/esg-indicator/type";
import { AssetClassLandAreaComponentModel, AssetClassLandAreaModel } from 'src/app/core/asset_class';
import { AssetClassSizeModel, AssetClassTenure } from 'src/app/core/comparable';

export class SpecialPurposeAssetClass {
  id: number;
  ref_num: string
  status: number
  formType: number

  location_data: LocationData

  add_info_on_land: boolean;
  land_parcel_name: string;
  coordinate_reference_system_id: number;
  points: any[];
  landArea: AssetClassLandAreaModel;
  boundary_type_id: number;
  landAreaComponents: AssetClassLandAreaComponentModel[] = [];

  property_type_id: number
  completion_year: string
  building_name: string
  property_grade_id: number
  above_floors: number
  below_floors: number
  handover_standard_id: number
  state_of_repair_id: number
  state_of_repair_description: string
  foundation_type_id: number
  developer: string
  anchor_tenant: string
  has_ancillary_buildings: boolean
  ancillary_buildings_num: number
  construction_desc: string

  accommodation: {
    id: number;
    data: Record<number, Record<string, number>>,
    others: {id: number, title: string}[],
    titles?: Record<string, string>
  }

  serviceAndInfraData: {
    id: number,
    road: boolean;
    status_n_quality: string,
    access_points: string,
    length_of_road: string,
    ownership: string,

    central_heating: boolean,
    heatings: number[],
    other_heating: string,

    all_of_it: boolean,
    services: number[],
    other_service: string
  }

  externalAspectData: ExternalAspectData
  internalAspectData: InternalAspectData

  grounds: {
    id: number,
    indoor_garage: number,
    indoor_garage_comment: string,

    outdoor_garage: number,
    outdoor_garage_comment: string,

    garden_id: number,
    garden_comment: string,

    outdoor_space_id: number,
    outdoor_space_comment: string,
  }
  sizes: AssetClassSizeModel[]

  buildings: AncillaryBuilding[]

  esgIndicator: EsgIndicator

  tenures: AssetClassTenure[]

  ac_pictures: any[];
  picture: string;
  documents: any[]

  // Misc
  size?: string
  can_be_deleted?: boolean
  userDeletedBy?: string
  deletedBy?: string
  createdBy?: string
  lastUpdatedBy?: string
  created_at?: string
  updated_at?: string
  used_times?: number

  constructor() {
    this.id = undefined
    this.ref_num = null
    this.status = 0
    this.formType = 2
    this.location_data = {
      country_id: null,
      city_id: null,
      zip_code: null,
      longitude: null,
      latitude: null,
      time_offset: null,
      location_grade_id: null,
      address: null,
      location_surrounding: null,
      city_of_location: null,
      boundary_type_id: null
    }
    this.add_info_on_land = false
    this.land_parcel_name = null
    this.coordinate_reference_system_id = null
    this.points = []
    this.landArea = new AssetClassLandAreaModel()
    this.landArea.clear()
    this.boundary_type_id = 1
    this.landAreaComponents = []

    this.property_type_id = null
    this.completion_year = null
    this.property_grade_id = null
    this.building_name = null
    this.above_floors = null
    this.below_floors = null
    this.handover_standard_id = null
    this.state_of_repair_id = null
    this.state_of_repair_description = null
    this.foundation_type_id = null
    this.developer = null
    this.anchor_tenant = null
    this.has_ancillary_buildings = false
    this.construction_desc = null

    this.accommodation = {
      id: undefined,
      data: {},
      others: []
    }

    this.serviceAndInfraData = {
      id: undefined,
      road: false,
      status_n_quality: null,
      access_points: null,
      length_of_road: null,
      ownership: null,

      central_heating: false,
      heatings: [],
      other_heating: null,

      all_of_it: false,
      services: [],
      other_service: null
    }

    this.externalAspectData = newExternalAspectData()

    this.internalAspectData = newInternalAspectData() 

    this.grounds = {
      id: undefined,
      indoor_garage: null,
      indoor_garage_comment: null,

      outdoor_garage: null,
      outdoor_garage_comment: null,

      garden_id: null,
      garden_comment: null,

      outdoor_space_comment: null,
      outdoor_space_id: null,
    }
    this.sizes = []
    this.buildings = []

    this.esgIndicator = null
    this.tenures = []

    this.ac_pictures = []
    this.picture = ''
    this.documents = []
  }
}

export class AncillaryBuilding {
  id: number
  uuid: string
  name: string
  completion_year: string
  floors: number
  construction_desc: string
  main_wall_id: number
  external_facade_id: number
  roof_covering_id: number
  size: number
  unit_id: number

  constructor() {
    this.uuid = uuidv4() 
    this.name = null
    this.completion_year = null
    this.floors = null
    this.construction_desc = null
    this.main_wall_id = null
    this.external_facade_id = null
    this.roof_covering_id = null
    this.size = null
    this.unit_id = null
  }
}